'use strict';

customerZone.factory('utils', ['$parse', '$window', '$location', '$q', '$timeout', '$log', 'config', 'gettextCatalog',
    'errorCode', function($parse, $window, $location, $q, $timeout, $log, config, gettextCatalog, errorCode){

        /**
         * Check an iccid.
         *
         * The input is a string; we expect either full iccid including the check digit,
         * or the significant digits of an iccid with the given IIN.
         *
         * @param input: iccid to validate
         * @param iins: [string] (optional).  The IINs of the operator the iccid should belong to.  If ommitted, only
         *  full iccids are allowed.  For Jim, the shorthand 'JIM' can be passed in. If multiple iins are possible,
         *  a comma-seperated string is accepted
         *
         * The output is an object with following fields:
         * valid: true or false
         * normalized: [if valid] the iccid in a normalized (full, no padding) form
         */
        var checkIccid = function(input, iins){

            var JIM_IINS = [
                '893230',
                '893203' // Note: these should be removed when we stop selling silent imsi sims
            ];

            if (iins === 'JIM') iins = JIM_IINS;

            if (!input) return {valid: false};
            if (input.length < 18 && iins) {
                for (var i = 0; i<iins.length; i++){
                    var iin = iins[i];
                    var forIin = checkIccid(iin + input);
                    if (forIin.valid) return forIin;
                }
                return {valid: false};
            }
            var match = /^(\d{19}\d?)F*$/.exec(input);
            if (!match) return {valid: false};
            input = match[1];

            if (!checkLuhn(input))
                return {valid: false};

            if (iins && iins.filter(isPrefixOfInput).length === 0)
                return {valid: false};

            return {
                valid: true,
                normalized: input
            };

            function isPrefixOfInput(prefix){
                return strStartsWith(input, prefix);
            }
        };

        var checkImei = function(input){
            if (!input) return {valid: false};
            if (isNaN(input)) return {valid: false};
            if (!(input.length === 15 || input.length ===17)) return {valid: false};
            if (!checkLuhn(input)) return {valid: false};
            return {valid: true};
        };

        /**
         * Check an msisdn.
         *
         * The input is a string; we expect either belgian or international format.  In the latter case, the prefix + or
         * dialout code (00) is ignored implicitly.  Other special characters are ignored automatically.
         *
         * The output is an object with following fields:
         * valid: true or false
         * normalized: [if valid] the msisdn in E164 form
         */
        var checkMsisdn = function(input){

            if (!input) return {valid: false};
            input = input.replace(/\/|\.|\s|\(|\)|-/g, ''); // cut off special chars
            input = input.replace(/(^\+320?)|(^00320?)|(^320?)|(^0)/g, ''); // cut off international prefixes

            if (!/^4(5|6|7|8|9)\d{7}$/.exec(input)) return  {valid: false}; // simple belgian format

            return {
                valid: true,
                normalized: '32'+input
            };
        };

        /**
         * Validates an email address
         * Regex taken from here: https://stackoverflow.com/a/46181/1977378
         * @param input the email candidate
         * @return {boolean} true if the input can be considered an email
         */
        var validateEmail = function(input){
            var re = new RegExp ('^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>(),[\\]\\.,;:\\s@\\"]+)*)' +
                '|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.' +
                '[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
            return re.test(input);
        };

        /**
         * Checks a VAT number. Accepts also old format.
         * @param input the VAT proposition
         * @return {*} an object with following fields:
         *  valid: whether or not the proposition is valid
         *  normalized (optional): VAT in a format workable for finance.
         */
        var checkVat = function(input){
            if (!input) return {valid: false};

            if (input.indexOf('BE') === -1)
                input = 'BE 0'+input; // converting it to recent format
            input = input.replace(/[\. ]/g, ''); // remove dots and spaces
            var match =  (/^BE([0-1][0-9]{3})([0-9]{3})([0-9]{3})$/.exec(input));
            if (!match) return {valid: false};
            input = 'BE '+match[1]+'.'+match[2]+'.'+match[3];

            return {
                valid: true,
                normalized: input
            };
        };


        /**
         * Verify that a number is correct according to Luhn's algorithm
         * https://en.wikipedia.org/wiki/Luhn_algorithm
         */
        var checkLuhn = function(input){
            var sum = 0;
            for (var i = 0; i<input.length; i++){
                var digit = parseInt(input[input.length - i - 1], 10);
                if (i%2 === 1){
                    digit *= 2;
                    if (digit > 9) digit -= 9;
                }
                sum += digit;
            }
            return sum % 10 === 0;
        };

        var strStartsWith = function(haystack, needle){
            if (haystack.length < needle.length) return false;
            return haystack.substring(0, needle.length) === needle;
        };

        /**
         * Get a field from a scope, and create and add it if it does not exist yet
         * @param scope scope to search in
         * @param expression expression to search for
         * @param ctor constructor to invoke if a new instance needs to be created
         * @returns an instance of the given constructor, either found or newly created.
         */
        var getOrCreate = function(scope, expression, ctor){
            var parsed = $parse(expression);
            var value = parsed(scope);
            if (!value) {
                value = new ctor();
                parsed.assign(scope, value);
            }
            return value;
        };

        /**
         * Simple translation function that redirects to ngTranslate
         */
        var translate = function(original, disallowFallback){
            var translated = gettextCatalog.getString(original);
            if (translated === original && disallowFallback) return '';
            return translated;
        };

        /**
         * Send the user to the login page
         * @param thenGoHere: if specified, redirect the user to this location after login
         * @param explanation: key to instruct the user why he needs to log in
         */
        var goToLogin = function(thenGoHere, explanation, emailLoginOnly){
            var params = {};
            if (thenGoHere) params.destination = thenGoHere;
            if (explanation) params.explanation = explanation;
            if (emailLoginOnly) params.emailLoginOnly = true;
            $location.path('/login').search(params);
        };

        /**
         * Send the user to the password reset page
         * @param thenGoHere: if specified, redirect the user to this location after reset
         * @param credentials: credentials to reset.  If provided, the reset token/mail will be sent immediately.
         */
        var goToReset = function(thenGoHere, credentials){
            var params = {};
            if (thenGoHere) params.destination = thenGoHere;
            if (credentials) params.credentials = credentials;
            $location.path('/reset_password').search(params);
        };

        /**
         * Send the user to the eservices home page
         */
        var goToHome = function(){
            $location.path('/');
        };

         /**
         * Send the user to the products page -- this serves as the homepage of the customer-zone
         */
        var goToProducts = function(){
            $location.path('/my_products');
        };

        var redirect = function(redirectUrl){
            if (isRelativePath(redirectUrl)) {
                $location.path(redirectUrl);
            }
            else {
                if (isSane()) {
                    $window.location.assign(redirectUrl);
                }
            }

            function isRelativePath() {
                return !/^\w+:/.test(redirectUrl);
            }

            function isSane() {
                return /^https?:/.exec(redirectUrl);
            }
        };

        /**
         * Get the full url of the current path
         */
        var currentPath = function(){
            return config.eserviceUrl+'#!'+$location.path();
        };

        /**
         * Remove secondary hash fragments from a URL to be used as a Mollie redirect URL.
         * @param url URL to clean as a string
         * @return cleaned URL as a string
         */
        var cleanUrlAsMollieRedirect = function(url){
            return url.replace(/(.*?#!\/[^#]*)(#?.*)/, '$1');
        };

        var messageHandles = {};

        /**
         * Show an informational message.
         * @param text text to show (will be localized)
         * @param correlationId optional. If passed, only the last message with that correlationId will be shown
         */
        var showSuccess = function(text, correlationId){
            $log.debug('Showing success '+text);
            var handle = toastr.success(translate(text));
            if (correlationId){
                hideMessage(messageHandles[correlationId]);
                messageHandles[correlationId] = handle;
            }
            return handle;
        };

        /**
         * Show an informational message.
         * @param text text to show (will be localized)
         * @param correlationId optional. If passed, only the last message with that correlationId will be shown
         */
        var showInfo = function(text, correlationId){
            $log.debug('Showing info '+text);
            var handle = toastr.info(translate(text));
            if (correlationId){
                hideMessage(messageHandles[correlationId]);
                messageHandles[correlationId] = handle;
            }
            return handle;
        };

        /**
         * Show an warning message.  The message will stay displayed until closed by user
         * @param text text to show (will be localized)
         * @param correlationId optional. If passed, only the last message with that correlationId will be shown
         * @param onDismiss optional. callback triggered when the user dismisses the message
         */
        var showWarn = function(text, correlationId, onDismiss){
            $log.debug('Showing warning '+text);
            var handle = toastr.warning(translate(text), '', {
                timeOut: '0',
                onCloseClick: onDismiss,
                tapToDismiss: !onDismiss
            });
            if (correlationId){
                hideMessage(messageHandles[correlationId]);
                messageHandles[correlationId] = handle;
            }
            return handle;
        };

        /**
         * Show an error message.
         * @param text text to show (will be localized)  If no text is given, a standard 'something blew up' message
         * is displayed.
         * @param correlationId optional. If passed, only the last message with that correlationId will be shown
         */
        var showError = function(text, correlationId){
            if (!text) text = translate('something_went_wrong') + ' '+ translate('try_again_or_call_care');
            $log.debug('Showing error '+text);
            var handle = toastr.error(translate(text), '', {timeOut: '0'});
            if (correlationId){
                hideMessage(messageHandles[correlationId]);
                messageHandles[correlationId] = handle;
            }
            return handle;
        };

        /**
         * Hide a previously shown error message. Unknown messages are ignored
         * @param handle Either the handle as returned from the show-function, or a correlationId if one was passed.
         */
        var hideMessage = function(handle){
            if (!handle) return;
            if (messageHandles[handle]) handle = messageHandles[handle];
            try {
                toastr.clear(handle);
            }
            catch (error){
                $log.debug('Toastr could not clear -- probably unknown handle', error);
            }
        };

        /**
         * Show the system is busy while a promise is resolving.
         *
         * When done, show a success message.  On errors, show an error message.
         *
         * @param promise Promise to execute
         * @param loadingMessage. The message to display while resolving (it will be automatically localized)
         * @param successMessage. The message to display when done (it will be automatically localized)
         * @param failureMessage. [optional] The message to display when failed (it will be automatically localized)
         * @return an object with three handlers:
         *  invoke freeze() to keep the busy spinner on the page forever (useful when leaving angular context)
         *  invoke cancel() to hide the indicator without showing success or failure
         *  invoke showError() to override the error message that will be shown
         *  invoke passThrough(errorMessage - Optional) will either hide the indicator if there is no string as param,
         *      otherwise it will replace the failureMessage with the one given as param then, either way, will pass
         *      through whatever response there was into the wrappedPromise
         *  use wrappedPromise to retrieve a promise that will resolve when showBusy has done its thing.  Since this
         *  includes standard error handling, that promise will never be rejected unless 'passThrough' was called.
         */
        var showBusy = function(promise, loadingMessage, successMessage, failureMessage){
            var indicatorId;
            var frozen = false;
            var cancelled = false;
            var passThroughInvoked = false;

            var wrappedPromise = promise.then(
                function(outcome){
                    if (cancelled) return outcome;
                    if (frozen) return outcome;
                    finalize('success', successMessage);
                    if (passThroughInvoked) return outcome;
                },
                function(error){
                    if (cancelled) return;

                    var text = translate('something_went_wrong') +' '+ translate('try_again_or_call_care');

                    // note: if a specific error message is set, we assume here that
                    // there is a user error, since a specific message is shown to the user.
                    // if not, it's considered an unintended error and we log it.
                    if (failureMessage)
                        text = translate(failureMessage);
                    else
                        $log.error('Error when loading... ' + loadingMessage, error);

                    finalize('error', text);

                    if ( passThroughInvoked ) throw error;

                }
            );

            var finalize = function(outcome, message) {
                indicatorId.removeClass('toast-busy');
                indicatorId.addClass('toast-'+outcome);
                indicatorId.find('.toast-message').html(translate(message));
                if (outcome!=='error')
                    setTimeout(function(){
                        hideIndicator();
                    }, 5000);
            };

            var showIndicator = function(){
                indicatorId = toastr.info(translate(loadingMessage), '',
                    {iconClass: 'toast-busy', timeOut: 0, extendedTimeOut: 0});
            };

            var showError = function(message){
                failureMessage = message;
                if (indicatorId){
                    indicatorId.addClass('toast-error');
                    indicatorId.find('.toast-message').html(translate(message));
                }
            };

            var passThrough = function(message){
                if (message) failureMessage = message;
                else hideIndicator();
                passThroughInvoked = true;
            };

            var hideIndicator = function(){
                toastr.clear(indicatorId);
            };

            showIndicator();

            return {
                freeze: function(){ frozen = true; },
                cancel: function(){ cancelled = true; hideIndicator(); },
                showError: showError,
                passThrough: passThrough,
                wrappedPromise: wrappedPromise
            };
        };

        /**
         * Internationalize a message and format it.  The format spec will be localized.
         * @param formatSpec a string containing placeholders like {this}. Use _this to capitalize a field value.
         * @param parameters an object with keys to fill in in the placeholder
         */
        var format = function(formatSpec, parameters){

            formatSpec = translate(formatSpec);

            var result = '';
            var lastPosition = 0;
            var pattern = /\{(_)?([^}]*)}/g;
            var match = pattern.exec(formatSpec);

            while (match) {
                var matchKey = match[2];
                var matchValue = parameters.hasOwnProperty(matchKey) ? parameters[matchKey] : '';
                if (match[1] === '_') matchValue = capitalize(matchValue);

                result += formatSpec.substr(lastPosition, pattern.lastIndex - lastPosition - match[0].length);
                result += matchValue;
                lastPosition = pattern.lastIndex;
                match = pattern.exec(formatSpec);
            }

            result += formatSpec.substr(lastPosition);

            return result;
        };

        var finterm = function(key, hasVat) {
            if (!key || hasVat) return key;
            return key
                .replace('an_invoice', 'a_payment_invitation')
                .replace('invoice', 'payment_invitation');
        };

        var legalDoc = function(doc) {
            var lang = config.language.substr(0, 2);
            return config.faktaApi.endpoint + '/legal-documents/jim/'+doc+'?language='+lang;
        };

        var capitalize = function(input){
            if (!input) return input;
            input = ''+input;
            return input.charAt(0).toUpperCase() + input.substr(1);
        };

        var runningPolls = [];

        /**
         * Poll a function until the result of it fulfills a given condition.
         * @param pollFunction A function to poll.  This may return a promise.
         * @param until A function to validate whether the result of the first function, or of it's resolved promise,
         *              can be considered a final answer.  This function must return true or false.
         * @param interval interval in milliseconds between two attempts
         * @param timeout timeout in milliseconds; after this the returned promise will be rejected
         * @param description a description of the thing we're polling for, for logging purposes.
         * @return a promise of the poll; which will resolve to the final response of the pollFunction if it adhered
         *         to the condition, or reject if the pollFunction had an error or if there was no decent answer in
         *         time.
         */
        var poll = function(pollFunction, until, interval, timeout, description){
            var deferred = $q.defer();
            var deadline = Date.now() + timeout;
            var cancelled = false;
            var poller = function(){
                if (cancelled) {
                    deferred.reject(errorCode.wrap(errorCode.POLL_CANCELLED, 'poll cancelled',
                        {pollCancelled: description}));
                    return;
                }
                $log.debug('Polling '+description);
                // see http://stackoverflow.com/a/20723813/396618
                $q.when('').then(pollFunction).then(function(response){
                    if (until(response))
                        deferred.resolve(response);
                    else {
                        if (Date.now() > deadline)
                            deferred.reject(errorCode.wrap(errorCode.POLL_TIMEOUT, 'poll timed out',
                                {pollTimeout: description}));
                        else
                            $timeout(poller, interval);
                    }
                }).catch(function(error){
                    if (cancelled) {
                        $log.debug('ignoring error on cancelled poll', error);
                        deferred.reject(errorCode.wrap(errorCode.POLL_CANCELLED, 'poll cancelled',
                            {pollCancelled: description}));
                    }
                    else
                        deferred.reject(error);
                });
            };
            poller();
            var pollHandle = {
                name: description,
                cancel: function(){ cancelled = true; }
            };
            runningPolls.push(pollHandle);
            var result = deferred.promise.finally(function(){
                var idx = runningPolls.indexOf(pollHandle);
                if (idx >= 0) runningPolls.splice(idx);
            });
            result.$poll = pollHandle;
            return result;
        };

        poll.cancelAll = function(){
            runningPolls.forEach(function(poll){
                poll.cancel();
            });
        };

        var lazyPromise = function(promiseFnc){
            var promise;
            return {
                then: function(resolve, reject){
                    if (promise === undefined)
                        promise = promiseFnc();
                    return promise.then(resolve, reject);
                },
                catch: function(reject){
                    if (promise === undefined)
                        promise = promiseFnc();
                    return promise.catch(reject);
                }
            };
        };

        /**
         * Wrap a function to make sure it only runs once at a time.
         * If a second invocation is one, we simply return the existing promise.
         * Any parameters are ignored, so this wrapper works best on
         * parameterless functions.
         * @param promiseFnc
         */
        var once = function(promiseFnc){
            var promise;
            return function(){
                if (promise === undefined){
                    promise = promiseFnc()
                        .finally(function(){
                            promise = undefined;
                        });
                }
                return promise;
            };
        };

        var debounce = function(wrapped, delay) {
            var handle;
            return function() {
                clearTimeout(handle);
                handle = setTimeout(function(){
                    handle = undefined;
                    wrapped();
                }, delay);
            };
        };

        var isoDateString = function(timestamp){
            if (!timestamp || !timestamp.isValid || !timestamp.isValid()) return '';
            return timestamp.utc().toISOString().split('T')[0];
        };

        var randomString = function(length) {
            var text = '';
            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            for (var i = 0; i < length; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        };

        var escapeHtml = function(input) {
            if (!input) return input;
            return input.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/'/g, '&quot;').replace(/'/g, '&#039;');
        };

        var escapeHtmlAndCurlies = function(input) {
            // Useful for stripping things like '{{ maliciousExpression }}' from user-modifiable input
            if (!input) return input;
            var strippedCurlies = input.replace(/{{[^}]*}}/g, '');
            return escapeHtml(strippedCurlies);
        };

        return {
            checkIccid: checkIccid,
            checkMsisdn: checkMsisdn,
            checkImei: checkImei,
            validateEmail: validateEmail,
            checkVat: checkVat,
            getOrCreate: getOrCreate,
            translate: translate,
            goToHome: goToHome,
            goToProducts: goToProducts,
            goToLogin: goToLogin,
            goToReset: goToReset,
            currentPath: currentPath,
            cleanUrlAsMollieRedirect: cleanUrlAsMollieRedirect,
            showSuccess: showSuccess,
            showInfo: showInfo,
            showWarn: showWarn,
            showError: showError,
            hideError: hideMessage,
            hideMessage: hideMessage,
            showBusy: showBusy,
            format: format,
            finterm: finterm,
            legalDoc: legalDoc,
            poll: poll,
            lazyPromise: lazyPromise,
            once: once,
            isoDateString: isoDateString,
            randomString: randomString,
            redirect: redirect,
            escapeHtml: escapeHtml,
            escapeHtmlAndCurlies: escapeHtmlAndCurlies,
            debounce: debounce
        };
    }]);
